import * as base from "./base";
import * as derived from "./derived";

/**
 * Element selectors namespace
 *
 * Usage:
 * - elements.all(state) - Get all elements
 * - elements.byUid('uid')(state) - Get element by UID
 * - elements.designators(state) - Get all element labels (memoized)
 * - elements.nonBranchPointElements(state) - Get non-branch point elements (memoized)
 */
export const elements = {
    ...base,
    ...derived,
} as const;

export type ElementsSelectors = typeof elements;
